import axios from "axios";

// Use the same origin the page is served from (works for both the domain
// and the raw IP), with an explicit override as fallback.
const configured = process.env.REACT_APP_BACKEND_URL;
export const API = configured ? `${configured}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Single-flight refresh: only one refresh request at a time; queued callers wait.
let refreshPromise = null;
async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API}/auth/refresh`, null, { withCredentials: true })
      .catch((err) => {
        // Refresh failed → clear the stale promise so future calls try again,
        // then rethrow so the original request fails with the 401.
        refreshPromise = null;
        throw err;
      });
  }
  try {
    await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}

// On 401, try to refresh the session once, then retry the original request.
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && !config._retried) {
      config._retried = true;
      try {
        await refreshSession();
        return api.request(config);
      } catch {
        // Refresh failed — propagate the original 401.
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
